// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import { GET_ALL_SERVICE_ORDER_PRICE, GET_CONFIG_APP, GET_DETAIL_FILE_BY_ID, GET_INFO_ORDER, GET_INFO_ORDER_DETAIL_FILE, GET_LIST_FILE_BY_ID, GET_PRICE_ORDER, POST_CREATE_ORDER, POST_CREATE_ORDER_FILE, POST_CREATE_ORDER_FILE_EDIT, POST_CREATE_ORDER_NO_LOGIN, POST_UPDATE_INFO_ORDER, UPLOAD_FILE_CREATE_ORDER } from "./constant";

export const PostCreateOrder = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: POST_CREATE_ORDER,
    payload,
    callback
  };
};

export const PostUpdateInfoOrder = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: POST_UPDATE_INFO_ORDER,
    payload,
    callback
  };
};

export const PostCreateOrderNoLogin = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: POST_CREATE_ORDER_NO_LOGIN,
    payload,
    callback
  };
};

export const GetAllService = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_ALL_SERVICE_ORDER_PRICE,
    payload,
    callback
  };
};

export const GetInfoOrder = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_INFO_ORDER,
    payload,
    callback
  };
};

export const GetPriceOrder = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_PRICE_ORDER,
    payload,
    callback
  };
};

export const GetConfigApp = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_CONFIG_APP,
    payload,
    callback
  };
};

export const UploadFileCreateOrder = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: UPLOAD_FILE_CREATE_ORDER,
    payload,
    callback
  };
};

export const GetListHistoryFileCreate = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_LIST_FILE_BY_ID,
    payload,
    callback
  };
};

export const GetDetailHistoryFileCreate = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_DETAIL_FILE_BY_ID,
    payload,
    callback
  };
};

export const PostCreateOrderFile = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: POST_CREATE_ORDER_FILE,
    payload,
    callback
  };
};


export const PostCreateOrderFileEdit = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: POST_CREATE_ORDER_FILE_EDIT,
    payload,
    callback
  };
};

export const GetInfoOrderDetailFileAction = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_INFO_ORDER_DETAIL_FILE,
    payload,
    callback
  };
};
